
export default {
    props: {
        height: {
            type: String,
            default: '15px'
        },
        maxWidth: {
            type: String,
            default: '100%'
        },
        borderRadius: {
            type: String,
            default: '10px',
        },
        loading: {
            type: Boolean,
            default: true,
        }
    }
}
